import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { error } from 'highcharts';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-ais-vessels',
  templateUrl: './ais-vessels.component.html',
  styleUrls: ['./ais-vessels.component.scss']
})
export class AisVesselsComponent {
RetriveData: any[] = [];
  paginatedData: any[] = [];
  vesselImoList: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 1;
  columnKeys: string[] = [];
  vesselName: any;
  isExpanded: boolean = false;
  filterForm: any;
  filteredData: any;
  elements: any;
  selectedShips: any;
  clientName: any;
  isFilterOpen = false;
map!: L.Map;
private baseLayer!: L.TileLayer;
 markers: L.Marker[] = [];
 showVesselLabels = false;
  cachedVesselFinderData: any;
  selectedVesselMarker: L.Marker | null = null;
pastTrackLayer: L.Polyline | null = null;
allMarkersLayer = L.layerGroup();
selectedVesselImo: string | null = null;
  constructor(
      private fb: FormBuilder,
      private requestFormService: RequestFormService,
      private toastr: ToastrService,
  ) {
    this.filterForm = this.fb.group({
          vesselName: [''],
          imoNumber: [''],
          vesselType:['all']
        });
  }
  ngOnInit(): void {
    this.getAisVessels();
    this.paginatedData = [];
    this.initMap();
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  getAisVessels(){
  this.requestFormService.getAisVessels().subscribe(data=>{
    this.elements = data.data;
     this.filteredData = this.elements; 
    this.paginateData();
  })
  }
  
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

    paginateData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    this.paginatedData = this.filteredData?.slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );
    this.loadPaginatedVesselsOnMap();
  }


filterClick() {
  const imoNumber = this.filterForm.value.imoNumber?.trim();
  const vesselName = this.filterForm.value.vesselName?.trim()?.toLowerCase();
  const vesselType = this.filterForm.value.vesselType;
  if (!this.elements || this.elements.length === 0) {
    this.toastr?.warning('No data available to filter.');
    return;
  }

  this.filteredData = this.elements.filter((item: any) => {
    const imoMatch = !imoNumber || item.imo?.toString() === imoNumber.toString();

    // Normalize both sides — remove spaces and lowercase
    const itemName = item.vessel_name?.toLowerCase()?.trim();
    const nameMatch = !vesselName || itemName?.includes(vesselName);

    const typeMatch = vesselType === 'all' || item.static === (vesselType === 'true');

    return imoMatch && nameMatch && typeMatch;
  });


  if (this.filteredData.length === 0) {
    this.toastr?.info('No matching records found.');
  }
   this.paginateData()
}





clearClick() {
  this.filterForm.reset();
  this.filteredData = this.elements; 
  this.paginateData()
}


isAddPopupOpen = false;

newVessel = {
  vessel_name: '',
  imo: '',
  static: true
};

openAddPopup() {
  this.isAddPopupOpen = true;
  this.newVessel = {
    vessel_name: '',
    imo: '',
    static: true
  };
}

addAisVessel() {
  this.requestFormService
    .addAisVessel(this.newVessel)
    .subscribe((res: any) => {
      this.isAddPopupOpen = false;
      this.toastr.success(res.message);
      this.getAisVessels();
  
    }, (error: any) => {
      this.toastr.error(error?.error?.message);
    });
}

deleteAisVessel(imo: string) {
  if (!confirm('Are you sure to delete this vessel?')) return;

  this.requestFormService
    .deleteAisVessel(imo)
    .subscribe((res: any) => {
      this.toastr.success(res.message);
      this.getAisVessels();
      
    }, (error: any) => {
      this.toastr.error(error?.error?.message);
    });
}

onImoChange() {
  const imo = this.newVessel.imo?.trim();

  if (imo && imo.length === 7) {
    this.requestFormService.getkplerList([imo]).subscribe(
      (res: any) => {
        if (res) {
        
          this.newVessel.vessel_name = res?.data[0].AIS.VESSEL_NAME;
        }
      },
      () => {
        this.newVessel.vessel_name = '';
      }
    );
  } else {
    this.newVessel.vessel_name = '';
  }
}


exportToCSV() {
  const headers = ['Vessel Name', 'IMO Number','Segment','Commercial Operator', 'Ingested Date','Deactivation Date'];

  const csvRows = [];

  csvRows.push(headers.join(','));

  this.filteredData.forEach((item: any) => {
    csvRows.push(
      [
        `"${item.vessel_name || ''}"`,
        `"${item.imo || ''}"`,
        `"${item.segment || ''}"`,
        `"${item.commercial_operator || ''}"`,
        `"${this.formatDate(item.ingested_date)}"`,
        `"${this.formatDate(item.deactivate_date)}"`
      ].join(',')
    );
  });

  const csvContent = csvRows.join('\n');

  const blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;'
  });

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `AIS_Vessels_${new Date().getTime()}.csv`;
  a.click();

  window.URL.revokeObjectURL(url);
}
formatDate(dateString: string): string {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return '';
  }

  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
}
initMap(): void {
    this.map = L.map('AISMap', {
      center: [34.553127, 18.048012],
      zoom: 2,
      minZoom: 2,
      zoomControl: true,
      attributionControl: false,
    });

    this.baseLayer = L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
      {
        maxNativeZoom: 16,
        maxZoom: 19
      }
    ).addTo(this.map);
    L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
      {
        maxNativeZoom: 16,
        maxZoom: 19
      }
    ).addTo(this.map);

  }
  
  addMarkers(vesselFinderData: any[]): void {
  this.allMarkersLayer.clearLayers(); 
  // Remove old markers
  this.markers.forEach((m: any) => this.map.removeLayer(m));
  this.markers = [];

  if (vesselFinderData.length > 0) {

    this.paginatedData.forEach((ship: any) => {

      const matched = vesselFinderData.find(
        (v: any) => Number(v?.AIS?.IMO) === Number(ship.imo)
      );

      if (
        matched?.AIS?.LATITUDE != null &&
        matched?.AIS?.LONGITUDE != null
      ) {

        const ais = matched.AIS;

        const newLat = Number(ais.LATITUDE);
        const newLng = Number(ais.LONGITUDE);

        ship.originalLng = newLng;

        if (ship.lng != null) {
          ship.lng = this.normalizeLongitude(
            newLng,
            Number(ship.lng)
          );
        } else {
          ship.lng = newLng;
        }

        ship.lat = newLat;
        if (!this.vesselTrackHistory[ship.imo]) {
            this.vesselTrackHistory[ship.imo] = [];
          }

          this.vesselTrackHistory[ship.imo].push([
            newLat,
            ship.lng
          ]);

          if (this.vesselTrackHistory[ship.imo].length > 100) {
            this.vesselTrackHistory[ship.imo].shift();
          }
        ship.speed = ais.SPEED;
        ship.destination = ais.DESTINATION;
        ship.last_updated = ais.TIMESTAMP;
        ship.mmsi = ais.MMSI;
        ship.eta = ais.ETA;

        ship.cog = ais.COG;
        ship.heading = ais.HEADING;
        ship.rot = ais.ROT;
        ship.navStatus = ais.NAV_STATUS;
        ship.vesselType = ais.VESSEL_TYPE;
        ship.flag = ais.FLAG;
        ship.draught = ais.DRAUGHT;

        ship.isLive = true;

      } else {
        ship.isLive = false;
      }
    });

  } else {

    this.paginatedData.forEach((ship: any) => {
      ship.isLive = false;
    });

  }

  // Auto zoom if one vessel
  if (this.paginatedData.length === 1) {

    const ship = this.paginatedData[0];

    if (ship?.lat != null && ship?.lng != null) {
      this.map.setView(
        [ship.lat, ship.lng],
        6,
        { animate: true }
      );
    }
  }

  // Add markers
  this.paginatedData.forEach((res: any) => {

    if (res.lat == null || res.lng == null) {
      return;
    }
    const isSelected = String(res.imo) === String(this.selectedVesselImo);
console.log(
  'IMO:', res.imo,
  'Selected:', this.selectedVesselImo,
  'isSelected:', isSelected
);
    const marker = L.marker(
  [res.lat, res.lng],
  {
    icon: this.createSimpleShipIcon(
  res.condition,
  res.vessel_name,
  this.map.getZoom(),
  res.vesselType,
  res.heading || res.cog || 0,
  isSelected
)
  }
);


marker.addTo(this.allMarkersLayer);
this.allMarkersLayer.addTo(this.map);

    this.markers.push(marker);

    const popup = `
      <div class="vessel-popup-card">
        <div class="popup-title">
          🚢 ${res.vessel_name || 'NA'}
          ${
            res.isLive
              ? '<span style="color:#22c55e;font-size:11px;"> ● LIVE</span>'
              : '<span style="color:#f59e0b;font-size:11px;"> ● EST</span>'
          }
        </div>

        <div class="popup-grid">
          <div>Destination</div>
          <div>${res.destination || 'NA'}</div>

          <div>ETA</div>
          <div>${res.eta || 'NA'}</div>

          <div>Status</div>
          <div>${this.getNavStatusLabel(res.navStatus)}</div>

          <div>Speed</div>
          <div>${res.speed ?? 'NA'} knots</div>

          <div>COG</div>
          <div>${this.formatCOG(res.cog)}</div>

          <div>Draught</div>
          <div>${res.draught ?? 'NA'} m</div>

          <div>Coordinates</div>
          <div>
            ${this.formatLatLng(res.lat, 'lat')},
            ${this.formatLatLng(res.originalLng ?? res.lng, 'lng')}
          </div>

          <div>Updated</div>
          <div>
            ${res.last_updated || 'NA'}
            ${
              res.last_updated
                ? this.getTimeAgo(res.last_updated)
                : ''
            }
          </div>
        </div>
      </div>
    `;

    marker.bindPopup(popup, {
      closeButton: false,
      offset: [0, -5],
      autoPan: false,
      className: 'vessel-popup'
    });
  marker.on('click', () => {
     this.allMarkersLayer.clearLayers();
  if (this.selectedVesselImo === res.imo) {
    this.trackLayerGroup.clearLayers();

  if (this.selectedVesselMarker) {
    this.map.removeLayer(this.selectedVesselMarker);
    this.selectedVesselMarker = null;
  }

  this.selectedVesselImo = null;

  if (this.pastTrackLayer) {
    this.map.removeLayer(this.pastTrackLayer);
    this.pastTrackLayer = null;
  }

  this.addMarkers(this.cachedVesselFinderData);
  } else {

    // New vessel selected
    this.selectedVesselImo = res.imo;

    this.showVesselPastTrack(res);
    this.addMarkers(this.cachedVesselFinderData);
  }

});
    // marker.on('mouseover', () => marker.openPopup());
    // marker.on('mouseout', () => marker.closePopup());
  });

  // Fit map to visible vessels
  const visibleMarkers = this.markers.filter(m => m.getLatLng());

  if (visibleMarkers.length > 1) {

    const group = L.featureGroup(visibleMarkers);

    this.map.fitBounds(group.getBounds(), {
      padding: [50, 50]
    });

  }
}

loadPaginatedVesselsOnMap() {
  const imoList = this.paginatedData
    ?.map((item: any) => item.imo)
    ?.filter((imo: any) => imo);

  if (!imoList || imoList.length === 0) {
    this.markers.forEach(marker => this.map.removeLayer(marker));
    this.markers = [];
    return;
  }

  this.requestFormService.getkplerList(imoList).subscribe({
    next: (res: any) => {
      this.cachedVesselFinderData = res?.data || [];
      this.addMarkers(this.cachedVesselFinderData);

    },
    error: (err) => {
      console.error('Error loading vessel positions:', err);
    }
  });
}

normalizeLongitude(currentLng: number, previousLng: number): number {
    let diff = currentLng - previousLng;

    if (diff > 180) {
      currentLng -= 360;
    } else if (diff < -180) {
      currentLng += 360;
    }

    return currentLng;
  }
  getDirection(deg: number): string {
    if (deg == null) return '';

    const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
    return dirs[Math.round(deg / 45) % 8];
  }

  formatCOG(cog: number): string {
    if (cog == null) return 'NA';
    return `${cog}° (${this.getDirection(cog)})`;
  }
  formatROT(rot: number): string {
    if (rot == null) return 'NA';
    if (rot === 0) return 'Straight';

    return rot > 0 ? `Right (${rot})` : `Left (${rot})`;
  }
  formatLatLng(value: number, type: 'lat' | 'lng'): string {
    if (value === null || value === undefined) return 'NA';

    const abs = Math.abs(value).toFixed(2);

    if (type === 'lat') {
      return `${abs}° ${value >= 0 ? 'N' : 'S'}`;
    } else {
      return `${abs}° ${value >= 0 ? 'E' : 'W'}`;
    }
  }

  getNavStatusLabel(status: number): string {
    const map: any = {
      0: 'Under way',
      1: 'At anchor',
      2: 'Not under command',
      3: 'Restricted maneuverability',
      4: 'Constrained by draught',
      5: 'Moored',
      6: 'Aground',
      7: 'Fishing',
      8: 'Moving under sail',
    };
    return map[status] || 'Unknown';
  }

  formatCourse(cog: number): string {
    if (cog == null) return 'NA';
    return `${cog}°`;
  }

  formatHeading(heading: number): string {
    if (heading == null) return 'NA';
    return `${heading}° (${this.getDirection(heading)})`;
  }
  getTimeAgo(timestamp: string): string {
    if (!timestamp) return '';

    const updatedTime = new Date(timestamp).getTime();
    const now = new Date().getTime();

    const diffMs = now - updatedTime;

    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));

    if (minutes < 1) return '(just now)';
    if (minutes < 60) return `(${minutes} min ago)`;
    if (hours < 24) return `(${hours} hr ago)`;

    const days = Math.floor(hours / 24);
    return `(${days} day${days > 1 ? 's' : ''} ago)`;
  }

   createSimpleShipIcon(
      voyageType: string,
      shipName: string,
      zoomLevel: number,
      vesselType: string = '',
      heading: number = 0,
      isSelected: boolean = false
    ): L.DivIcon {
      let size = this.getIconSize(zoomLevel) + 6;
      if (isSelected) {
        size = 25;
      }else{
        size = 18;
      }
      const opacity =
          this.selectedVesselImo &&
          !isSelected
            ? 0.3
            : 1;
      const isBallast = voyageType === 'Ballast';
  
      const hullColor = this.getVesselTypeColor(vesselType);
  
      // ✅ AIS alignment fix
      const rotation = (heading || 0) + 90;


  
      return L.divIcon({
        className: 'realistic-vessel-icon',
        html: `
      <div style="
        display:flex;
        flex-direction:column;
        align-items:center;
        transform:translateY(-8px);
        position:relative;
      ">
  
       
  
        <!-- YOUR EXACT SHIP SHAPE + ROTATION -->
        <svg
          width="${size * 1.6}"
          height="${size * 0.8}"
          viewBox="0 0 100 40"
          style="
            opacity:${opacity};
            z-index:2;
            transform: rotate(${rotation}deg);
            transform-origin:50% 50%;
            transition:all .3s ease;
            filter:drop-shadow(0 3px 6px rgba(0,0,0,.4));
          "
        >
          <polygon points="0,20 15,5 15,35" fill="${hullColor}"/>
          <rect x="15" y="8" width="55" height="24" fill="${hullColor}"/>
          <rect x="70" y="10" width="20" height="20"
            fill="white" stroke="${hullColor}" stroke-width="2"/>
          <rect x="90" y="12" width="6" height="16" fill="${hullColor}"/>
        </svg>
  
        ${(this.showVesselLabels || isSelected) ? `
          <div style="
            margin-top:-3px;
            padding:3px 9px;
            font-size:10px;
            font-weight:700;
            color:#ffffff;
            background:#192a4c;
            border-radius:14px;
            white-space:nowrap;
            box-shadow:0 2px 6px rgba(0,0,0,0.35);
          ">
            ${shipName || 'NA'}
          </div>
          ` : ''}
  
  
      </div>
      `,
        iconSize: [size * 1.8, size],
        iconAnchor: [size * 0.9, size / 2],
      });
    }
      getIconSize(zoomLevel: number): number {
    return Math.min(Math.max(zoomLevel * 2, 12), 40);
  }
  toggleLabels() {
    this.showVesselLabels = !this.showVesselLabels;
  this.addMarkers(this.cachedVesselFinderData);
}

getVesselTypeColor(vesselType: string): string {
  const type = (vesselType || '').toLowerCase();

  if (type.includes('tanker')) {
    return '#da8e25'; // Red
  }

  if (type.includes('container')) {
    return '#1e88e5'; // Blue
  }

  if (type.includes('bulk')) {
    return '#fb8c00'; // Orange
  }

  if (type.includes('lng') || type.includes('gas')) {
    return '#8e24aa'; // Purple
  }

  if (type.includes('passenger')) {
    return '#43a047'; // Green
  }

  if (type.includes('Crude Oil Tanker')) {
    return '#795548'; // Brown
  }

  if (type.includes('tug')) {
    return '#546e7a'; // Grey Blue
  }

  return '#7C2020'; // Default
}
vesselTrackHistory: {
  [imo: string]: [number, number][]
} = {};
vesselTrackCache: {
  [imo: string]: [number, number][];
} = {};
trackLayerGroup = L.layerGroup();
showVesselPastTrack(vessel: any): void {

  this.trackLayerGroup.clearLayers();

  if (this.pastTrackLayer) {
    this.map.removeLayer(this.pastTrackLayer);
  }

  const cachedTrack = this.vesselTrackCache[vessel.imo];

  if (cachedTrack) {
    this.drawTrack(cachedTrack);
    return;
  }

  this.requestFormService.getAisTrack(vessel.imo).subscribe({
    next: (response: any[]) => {

      const history: [number, number][] =
        response.map(point => [point.lat, point.lng]);

      this.vesselTrackCache[vessel.imo] = history;

      this.drawTrack(history);
    }
  });
}

drawTrack(history: [number, number][]) {

  if (history.length <= 1) {
    return;
  }

  L.polyline(history, {
    color: '#FFFFFF',
    weight: 7,
    opacity: 0.9
  }).addTo(this.trackLayerGroup);

  this.pastTrackLayer = L.polyline(history, {
    color: '#1E88E5',
    weight: 4,
    opacity: 1
  }).addTo(this.trackLayerGroup);

  this.trackLayerGroup.addTo(this.map);

  this.map.fitBounds(
    this.pastTrackLayer.getBounds(),
    { padding: [50, 50] }
  );
}
showAllVessels(): void {

  this.selectedVesselImo = null;

  if (this.pastTrackLayer) {
    this.map.removeLayer(this.pastTrackLayer);
    this.pastTrackLayer = null;
  }

  this.addMarkers(this.cachedVesselFinderData);
}



sortData(sort: Sort) {

  const data = [...this.filteredData];

  if (!sort.active || sort.direction === '') {
    this.filteredData = data;
    this.paginateData();
    return;
  }

  this.filteredData = data.sort((a, b) => {

    let valueA: any = a[sort.active];
    let valueB: any = b[sort.active];

    // Handle dates
    if (
      sort.active === 'ingested_date' ||
      sort.active === 'deactivate_date'
    ) {
      valueA = valueA ? new Date(valueA).getTime() : 0;
      valueB = valueB ? new Date(valueB).getTime() : 0;
    }

    // Handle strings
    if (typeof valueA === 'string') {
      valueA = valueA.toLowerCase();
      valueB = valueB?.toLowerCase();
    }

    const comparison =
      valueA < valueB ? -1 :
      valueA > valueB ? 1 : 0;

    return sort.direction === 'asc'
      ? comparison
      : -comparison;
  });

  this.currentPage = 1;
  this.paginateData();
}
}
